import Box from '@mui/material/Box';
import TasksSummary from '../components/TasksSummary';
import AssignedTasksSummary from '../components/AssignedTasksSummary';
import '../Workbench.css';
import DiscoveryRefreshesSummary from '../components/DiscoveryRefreshesSummary';
import Files from '../components/Files';
import EmbeddedCalendar from '../components/EmbeddedCalendar';
import { TAB_KEYS } from '../components/Tabs';

const PersonalMainLayout = ({ onNavigateTab }) => {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridTemplateRows: '1fr auto',
        gap: 2,
        pb: 4,
      }}
    >
      <Box className="workbench-card" sx={{ gridRow: '1 / 3', overflow: 'hidden' }}>
        <EmbeddedCalendar />
      </Box>
      <Box className="workbench-card">
        <Files />
      </Box>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3, 1fr)',
          gap: 2,
        }}
      >
        <Box className="workbench-card">
          <TasksSummary onOpenTaskManager={() => onNavigateTab?.(TAB_KEYS.TASKS)} />
        </Box>
        <Box className="workbench-card">
          <AssignedTasksSummary />
        </Box>
        <Box className="workbench-card">
          <DiscoveryRefreshesSummary />
        </Box>
      </Box>
    </Box>
  );
};

export default PersonalMainLayout;
